import { render, staticRenderFns } from "./CreateRate.vue?vue&type=template&id=1b7b5c48"
import script from "./CreateRate.vue?vue&type=script&lang=js"
export * from "./CreateRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports